import React from "react";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import QualityEnum, { getQualityOptions } from "../../../enums/QualityEnum";

const CompressionDropdown = ({ value, onChange, disabled }) => {
  const options = getQualityOptions();

  return (
    <Dropdown disabled={disabled}>
      <Dropdown.Toggle variant="dark" id="dropdown-compression">
        {options.find((option) => option.value === value)?.label || "Compressão"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => onChange(option.value)}>
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

CompressionDropdown.propTypes = {
  value: PropTypes.oneOf([...Object.values(QualityEnum), null]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CompressionDropdown.defaultProps = {
  value: null,
  disabled: false,
};

export default CompressionDropdown;